module.exports = __webpack_public_path__ + "static/media/videopreview.1e868f07.png";